export default __webpack_public_path__ + "static/img-app-explain--mobile-de33c70dbd10cc9b3eead3857628201a.jpg";